import React from 'react';

function Footer() {
 return(
    <div className="container-fluid footer-section">
        <div className="row">
            <div className="col-md-12">
                <h6 className="text-center">Copyright <span>&copy;</span> {(new Date().getFullYear())} Muhammad Yaseen. All Right Reserved</h6>
            </div>
        </div>  
    </div>
  );
}

export default Footer;

